import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '@/components/PrimaryButton';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Stack spacing={2} alignItems="flex-start">
      <Typography variant="overline" color="secondary.main" sx={{ letterSpacing: '0.18em' }}>
        PÁGINA NO ENCONTRADA
      </Typography>
      <Typography variant="h2">Esta página no está disponible.</Typography>
      <Typography variant="body1" color="text.secondary">
        Volvé al catálogo para seguir navegando.
      </Typography>
      <PrimaryButton onClick={() => navigate('/catalog')}>Volver al catálogo</PrimaryButton>
    </Stack>
  );
}
